import { useState } from 'react';

import ArrowDownIcon from '@/assets/svg/ui-elements/arrow-down.svg';
import ArrowUpIcon from '@/assets/svg/ui-elements/arrow-up.svg';
import ArrowUpRightIcon from '@/assets/svg/ui-elements/arrow-up-right.svg';
import ShieldOutlineIcon from '@/assets/svg/ui-elements/shield-outline.svg';
import { Tooltip } from '@/design-system';
import { useIsMobile } from '@/global-hooks/use-is-mobile';
import { CryptoAsset } from '@/shared/modules/wallet/use-crypto-assets';

import { ReceiveModal } from '../transfers/receive/receive-modal';
import { useOpenReceive } from '../transfers/receive/use-open-receive';
import { SendModal } from '../transfers/send/send-modal';
import { useOpenSend } from '../transfers/send/use-open-send';
import { CollateralizeModal } from './collateralize-modal';
import { ActionButton, Row } from './row-actions.styled';
import { SellModal } from './sell-modal';

type ActiveModal = 'send' | 'receive' | 'collateralize' | 'sell' | null;

interface RowActionsProps {
  coin: CryptoAsset;
  assets: CryptoAsset[];
  suiAddress: string | undefined;
}

export const RowActions = ({ coin, assets, suiAddress }: RowActionsProps) => {
  const isMobile = useIsMobile();
  const [activeModal, setActiveModal] = useState<ActiveModal>(null);
  const close = () => setActiveModal(null);
  const openSend = useOpenSend({
    isMobile,
    onOpenModal: () => setActiveModal('send'),
  });
  const openReceive = useOpenReceive({
    isMobile,
    onOpenModal: () => setActiveModal('receive'),
  });

  return (
    <>
      <Row onClick={(event) => event.stopPropagation()}>
        <Tooltip title={`Receive ${coin.symbol}`} side="top">
          <ActionButton
            variant="outline"
            color="secondary"
            size="sm"
            aria-label={`Receive ${coin.symbol}`}
            onClick={() => openReceive(coin)}
          >
            <ArrowDownIcon />
          </ActionButton>
        </Tooltip>
        <Tooltip title={`Send ${coin.symbol}`} side="top">
          <ActionButton
            variant="outline"
            color="secondary"
            size="sm"
            aria-label={`Send ${coin.symbol}`}
            onClick={() => openSend(coin.coinType)}
          >
            <ArrowUpIcon />
          </ActionButton>
        </Tooltip>
        <Tooltip title="Coming Soon" side="top">
          <span>
            <ActionButton
              variant="outline"
              color="secondary"
              size="sm"
              disabled
              aria-label={`Collateralize ${coin.symbol}`}
            >
              <ShieldOutlineIcon />
            </ActionButton>
          </span>
        </Tooltip>
        <Tooltip title="Coming Soon" side="top">
          <span>
            <ActionButton
              variant="outline"
              color="secondary"
              size="sm"
              disabled
              aria-label={`Sell ${coin.symbol}`}
            >
              <ArrowUpRightIcon />
            </ActionButton>
          </span>
        </Tooltip>
      </Row>

      <SendModal
        open={activeModal === 'send'}
        onClose={close}
        assets={assets}
        senderAddress={suiAddress}
        initialCoin={coin}
      />
      <ReceiveModal
        open={activeModal === 'receive'}
        onClose={close}
        coin={coin}
        suiAddress={suiAddress}
      />
      <CollateralizeModal open={activeModal === 'collateralize'} onClose={close} coin={coin} />
      <SellModal open={activeModal === 'sell'} onClose={close} coin={coin} />
    </>
  );
};
